import type { Requests } from "../common/request.common";
import type { MarketingSubscriptionResponseTypes } from "../common/response.common";
import { post } from "./common";

export const marketingSubscription = {
    record(data: typeof Requests.MarketingSubscription.Record.Input) {
        return post<typeof data, MarketingSubscriptionResponseTypes.Record>(
            `/marketing-subscription/record`,
            data,
        );
    },
};
